const inject = ['$stateParams', '$uibModal', 'shipmentService', '$state', 'ogsdk.addressOrchestrator', '$document'];

function EditShippingModal($stateParams, $uibModal, shipmentService, $state, addressOrchestrator, $document) {
  this.open = function() {
    const modal = $uibModal.open({
      template: '<div ui-view="shipping"></div>',
      backdrop: true,
      windowTopClass: 'og-shipping-edit',
      ariaLabelledBy: 'og-shipping-edit-modals-title'
    });

    modal.rendered.then(() => $document[0].querySelector('.og-modal-window').setAttribute('aria-modal', true));

    return modal.result
      .then(
        () => $state.go('root', {}, { reload: true }),
        () => $state.go('root')
      );
  };

  this.submit = function(selectedId, useForAll) {
    if (useForAll) {
      return addressOrchestrator.useShippingAddressForAll(selectedId);
    }

    return shipmentService.setShippingForSubscriptions($stateParams.shipment, selectedId);
  };
}

EditShippingModal.$inject = inject;

module.exports = EditShippingModal;
